import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Button } from 'seagull';
import { FaceId, Fingerprint } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { useIoContext } from '~/providers/IoContext';
import { useBiometricLogin } from '../hooks/useBiometricLogin';
export const GetBiometricLoginButtonTID = (parentTestId)=>getTestIds(parentTestId);
export const BiometricLoginButton = (param)=>{
    let { testId = '' } = param;
    const { native } = useIoContext();
    const { BiometricLoginButtonTestIds } = useMemo(()=>GetBiometricLoginButtonTID(testId), [
        testId
    ]);
    const { visible, loading, method, signIn } = useBiometricLogin(BiometricLoginButtonTestIds.ErrorToast());
    const { t: loginTexts } = useLocaleKeys('auth.screens.login');
    if (!visible) {
        return null;
    }
    const icon = native.platform === 'ios' ? /*#__PURE__*/ _jsx(FaceId, {
        testId: BiometricLoginButtonTestIds.FaceIdIcon()
    }) : /*#__PURE__*/ _jsx(Fingerprint, {
        testId: BiometricLoginButtonTestIds.FingerprintIcon()
    });
    return /*#__PURE__*/ _jsx(Button, {
        testId: BiometricLoginButtonTestIds.Root(),
        bi: {
            name: 'biometric_login'
        },
        skin: "primaryOutline",
        fluid: true,
        loading: loading,
        onClick: signIn,
        prefixIcon: icon,
        children: loginTexts.biometricSignIn({
            method
        })
    });
};
